<template>
  <div class="welcome">
    <div
      lg="5"
      class="welcome__hero welcome-1"
    >
      <h1 class="display-1">
        My College Plan
      </h1>
    </div>
    <div class="welcome__content text-center welcome-2">
      <div align-h="center">
        <p class="sub-header">
            Take your future for a test drive.
          </p>
          <p class="mb-0">
            Compare college costs, check out potential careers and earnings of college majors, and determine your college investment.
          </p>
      </div>
      <div class="categories">
        <div class="category">
          <icon-school />
          <p>Compare college costs.</p>
        </div>
        <div class="category">
          <icon-book />
          <p>Match skills to possible majors and careers.</p>
        </div>
        <div class="category">
          <icon-briefcase />
          <p>
            Find out what you could earn
            <span class="text-nowrap text-reset">after graduation.</span>
          </p>
        </div>
      </div>
      <div align-h="center" class="welcome__cta">
        <div md="9">
          <b-button v-on:click="start" variant="primary" block
            >Get Started</b-button
          >
        </div>
      </div>
      <div align-h="center">
        <div lg="11" cols="12" class="text-left">
          <disclaimer />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSchool from "./animatedicons/IconSchool.vue";
import IconBook from "./animatedicons/IconBook.vue";
import IconBriefcase from "./animatedicons/IconBriefcase.vue";
import Disclaimer from "./Disclaimer.vue";

export default {
  name: "Welcome",
  methods: {
    start: function() {
      this.$emit("started");
    }
  },
  components: {
    IconSchool,
    IconBook,
    IconBriefcase,
    Disclaimer
  }
};
</script>

<style scoped></style>
